export const locale = {
  lang: 'pt',
  data: {
    'CONTRO_ENCU': {
      'TIT_ENCABE': 'Controlo dos inquéritos',
      'CHAN_INFO': 'Carregamento de informação',
      'TEX_INTRUCC':'* Efectuar pesquisa seleccionando filtro(s)',
      'SELEC_INSTI': 'Instituto',
      'SELEC_YEA': 'Ano',
      'SELEC_TI_ENC':'Produtos',
      'SELEC_ESTA': 'Status',
      'BTN_FIL_INFO': 'Inquéritos com filtro',
      'COMFI_UPDA_TEX': 'Tem a certeza de que vai actualizar?',
      'BTN_ACEP': 'Aceitar',
      'BTN_CANC': 'Cancelar',
      'TEX_MOD_UPTD':'Actualização',
      'TEX_SUCC_MOD_UPTD': 'Actualizado com sucesso',
      'USE': 'Usuário:',
      'DAT':'Data:',
      'ACC': 'Ação:',
      'ACC_EVENT':{
      '0': 'Desativado',
      '1':'Ativado',
    },
      'NAM_TH':{
        'TH_NAM':'Empresa',
         'TH_TI_ENCU': 'Tipo de inquérito',
         'TH_DAT_APLI': 'Data de candidatura',
         'TH_ESTA':'Status',
         'TH_TOKE': 'Token',
         'TH_HC':'HC',
         'TH_RESPU': 'Respostas',
         'TH_DAT_CLO':'Data de encerramento',
         'TH_PRORR': 'Rollover',
         'TH_REPO_EXC': 'Relatório Excel',
         'TH_ONLI': 'Online',
         'TH_OFFLI': 'Offline',
         'TH_AUDIT': 'Auditoria',
         'TH_SECT':'Sector',
         'TH_SUBSECT': 'Sub sector',
         'TH_LIPROY': 'Project Leader',
         'TH_JEFPROY': 'Project leader',
      }
    },

  }
};
